import {
  ADD_SUBMISSION_DATA_SIGNET_LOOK,
  ADD_SUBMISSION_DATA_SIGNET_LOOK_START,
  ADD_SUBMISSION_DATA_SIGNET_LOOK_ERROR,
  GET_SUBMISSION_DATA_SIGNET_LOOK,
  GET_SUBMISSION_DATA_SIGNET_LOOK_START,
  GET_SUBMISSION_DATA_SIGNET_LOOK_ERROR,
  GET_SUBMISSION_DATA_SIGNET_LOOK_CONTENT_FOR_PREVIEW,
  GET_SUBMISSION_DATA_SIGNET_LOOK_CONTENT_FOR_PREVIEW_START,
  GET_SUBMISSION_DATA_SIGNET_LOOK_CONTENT_FOR_PREVIEW_ERROR,
  GET_SUBMISSION_DATA_SIGNET_LOOK_LIST,
  GET_SUBMISSION_DATA_SIGNET_LOOK_LIST_ERROR,
  GET_SUBMISSION_DATA_SIGNET_LOOK_LIST_START,
  GET_SUBMISSION_DATA_SIGNET_LOOK_LIST_PAGEABLE,
  REMOVE_SUBMISSION_DATA_SIGNET_LOOK,
  CLEAR_ERROR_SUBMISSION_DATA_SIGNET_LOOK,
  CLEAR_LOOK_CONTETNT,
} from '../actions/types';

const initialState = {
  submissionDataSignetLookAttachment: {},
  loading: false,
  error: undefined,
  attachmentContent: [],
  submissionDataSignetLookAttachmentList: [],
  totalElements: '',
};

const clearLookContetnt = (state) => {
  return {
    ...state,
    submissionDataSignetLookAttachment: {},
  };
};

const clearError = (state) => {
  return {
    ...state,
    error: undefined,
    attachmentContent: [],
  };
};

const addSubmissionDataSignetLookStart = (state) => {
  return {
    ...state,
  };
};

const addSubmissionDataSignetLook = (state, action) => {
  return {
    ...state,
    loading: false,
    submissionDataSignetLookAttachment: action.payload,
  };
};

const addSubmissionDataSignetLookError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const findSubmissionDataSignetLookByLatestVersioneStart = (state) => {
  return {
    ...state,
    loading: true,
  };
};

const findSubmissionDataSignetLookByLatestVersione = (state, action) => {
  return {
    ...state,
    loading: false,
    submissionDataSignetLookAttachment: action.payload,
  };
};

const findSubmissionDataSignetLookByLatestVersioneError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const findSubmissionDataSignetLookByNameStart = (state) => {
  return {
    ...state,
    //loading: true,
  };
};

const findSubmissionDataSignetLookByName = (state, action) => {
  return {
    ...state,
    loading: false,
    attachmentContent: action.payload,
  };
};

const findSubmissionDataSignetLookByNameError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const removeAttachment = (state) => {
  return {
    ...state,
    attachmentContent: [],
  };
};

const findAllSubmissionDataSignetLookStart = (state) => {
  return {
    ...state,
    loading: true,
  };
};

const findAllSubmissionDataSignetLook = (state, action) => {
  return {
    ...state,
    loading: false,
    submissionDataSignetLookAttachmentList: action.payload,
  };
};

const findAllSubmissionDataSignetLookError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const findAllSubmissionDataSignetLookPageable = (state, action) => {
  return {
    ...state,
    loading: false,
    submissionDataSignetLookAttachmentList: action.payload[0],
    numberOfPages: action.payload[1],
    totalElements: action.payload[2],
  };
};

export default function (state = initialState, action) {
  switch (action.type) {
    case ADD_SUBMISSION_DATA_SIGNET_LOOK:
      return addSubmissionDataSignetLook(state, action);
    case ADD_SUBMISSION_DATA_SIGNET_LOOK_START:
      return addSubmissionDataSignetLookStart(state);
    case ADD_SUBMISSION_DATA_SIGNET_LOOK_ERROR:
      return addSubmissionDataSignetLookError(state, action);

    case GET_SUBMISSION_DATA_SIGNET_LOOK:
      return findSubmissionDataSignetLookByLatestVersione(state, action);
    case GET_SUBMISSION_DATA_SIGNET_LOOK_START:
      return findSubmissionDataSignetLookByLatestVersioneStart(state);
    case GET_SUBMISSION_DATA_SIGNET_LOOK_ERROR:
      return findSubmissionDataSignetLookByLatestVersioneError(state, action);

    case GET_SUBMISSION_DATA_SIGNET_LOOK_CONTENT_FOR_PREVIEW:
      return findSubmissionDataSignetLookByName(state, action);
    case GET_SUBMISSION_DATA_SIGNET_LOOK_CONTENT_FOR_PREVIEW_START:
      return findSubmissionDataSignetLookByNameStart(state);
    case GET_SUBMISSION_DATA_SIGNET_LOOK_CONTENT_FOR_PREVIEW_ERROR:
      return findSubmissionDataSignetLookByNameError(state, action);

    case REMOVE_SUBMISSION_DATA_SIGNET_LOOK:
      return removeAttachment(state);

    case CLEAR_ERROR_SUBMISSION_DATA_SIGNET_LOOK:
      return clearError(state);

    case GET_SUBMISSION_DATA_SIGNET_LOOK_LIST:
      return findAllSubmissionDataSignetLook(state, action);
    case GET_SUBMISSION_DATA_SIGNET_LOOK_LIST_START:
      return findAllSubmissionDataSignetLookStart(state);
    case GET_SUBMISSION_DATA_SIGNET_LOOK_LIST_ERROR:
      return findAllSubmissionDataSignetLookError(state, action);

    case GET_SUBMISSION_DATA_SIGNET_LOOK_LIST_PAGEABLE:
      return findAllSubmissionDataSignetLookPageable(state, action);

    case CLEAR_LOOK_CONTETNT:
      return clearLookContetnt(state);

    default:
      return state;
  }
}
